import { useQuery, useMutation } from '@tanstack/react-query';

export function useHeroSectionData() {
    return useQuery({
        queryKey: ['heroSectionData'],
        queryFn: async () => {
            const url = process.env.REACT_APP_BASE_URL + '/webdata/hero/all';
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            return data.data;
        }
    });
}

export function useFeatureCards() {
    return useQuery({
        queryKey: ['featureCards'],
        queryFn: async () => {
            const url = process.env.REACT_APP_BASE_URL + '/webdata/feature-cards/';
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            return data.data;
        }
    });
}

export function useImportantDates() {
    return useQuery({
        queryKey: ['importantDates'],
        queryFn: async () => {
            const url = process.env.REACT_APP_BASE_URL + '/webdata/important-dates/';
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            return data.data;
        }
    });
}

export function useTeachers() {
    return useQuery({
        queryKey: ['teachers'],
        queryFn: async () => {
            const url = process.env.REACT_APP_BASE_URL + '/webdata/teachers/';
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            return data.data;
        }
    });
}

export function useCollaboratingCompanies() {
    return useQuery({
        queryKey: ['collaboratingCompanies'],
        queryFn: async () => {
            const url = process.env.REACT_APP_BASE_URL + '/webdata/companies/';
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            return data.data;
        }
    });
}

export function useStatistics() {
    return useQuery({
        queryKey: ['statistics'],
        queryFn: async () => {
            const url = process.env.REACT_APP_BASE_URL + '/webdata/statistics/';
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            return data.data;
        }
    });
}

export function useWebCourses() {
    return useQuery({
        queryKey: ['webCourses'],   
        queryFn: async () => {
            const url = process.env.REACT_APP_BASE_URL + '/web-courses/active';
            const response = await fetch(url, { cache: 'no-store' });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            return data.data;
        }
    });
}

export function useWebCoursesForms() {
    return useQuery({
        queryKey: ['webCoursesForms'],
        queryFn: async () => {
            const url = process.env.REACT_APP_BASE_URL + '/web-course-registrations/forms/';
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            return data.data;
        }
    });
}

export function useFormsQuestions(formId, enabled = true) {
    return useQuery({
        queryKey: ['formsQuestions', formId],
        enabled,
        queryFn: async () => {
            const url = process.env.REACT_APP_BASE_URL + `/web-course-registrations/questions/form/${formId}`;
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            return data;
        }
    });
}

export function useSubmitForm() {
    return async (formData) => {
        const url = process.env.REACT_APP_BASE_URL + `/web-course-registrations/results/submit`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data;
    }
}

export function useSubmitContactForm() {
    return useMutation({
        mutationFn: async (contactData) => {
            const url = process.env.REACT_APP_BASE_URL + '/web-contact-us/create';
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(contactData),
            });
            
            const data = await response.json();
            
            if (!response.ok) {
                throw new Error(data.error || 'Failed to send message');
            }
            
            return data;
        }
    });
}

export function useWebCourseFAQs(webCourseId) {
    return useQuery({
        queryKey: ['webCourseFAQs', webCourseId],
        queryFn: async () => {
            const url = process.env.REACT_APP_BASE_URL + `/web-course-faqs/web-course/${webCourseId}`;
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            return data.data;
        },
        enabled: !!webCourseId
    });
}
